"use client";

import { Button } from "@web/components/ui/button";
import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
} from "@web/components/ui/dialog";
import { useLanguage } from "@web/lib/contexts/language-context";
import { Equal, Focus, Scan, Sun } from "lucide-react";

interface SeloModalProps {
	open: boolean;
	onOpenChange: (open: boolean) => void;
}

export function SealPositionAlert({ open, onOpenChange }: SeloModalProps) {
	const { t } = useLanguage();

	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent className="rounded-3xl w-[90vw] p-6">
				<DialogHeader className="flex flex-row items-center justify-center gap-2 mb-2">
					<DialogTitle className="text-base font-semibold text-zinc-900">
						{t.camera.instructions.title}
					</DialogTitle>
				</DialogHeader>

				<div className="space-y-5 mt-2">
					<p className="text-sm text-zinc-600">
						{t.camera.instructions.description}
					</p>
					<div className="flex items-start gap-4">
						<Equal
							className="h-6 w-6 text-red-500 shrink-0"
							strokeWidth={1.5}
						/>
						<div>
							<h3 className="font-semibold text-zinc-900">
								{t.qrCodePage.sealModal.usedSealTitle}
							</h3>
							<p className="text-sm text-zinc-500">
								{t.qrCodePage.sealModal.usedSealDesc}
							</p>
						</div>
					</div>

					<div className="flex items-start gap-4">
						<Sun className="h-6 w-6 text-red-500 shrink-0" strokeWidth={1.5} />
						<div>
							<h3 className="font-semibold text-zinc-900">
								{t.qrCodePage.sealModal.lightingTitle}
							</h3>
							<p className="text-sm text-zinc-500">
								{t.qrCodePage.sealModal.lightingDesc}
							</p>
						</div>
					</div>

					<div className="flex items-start gap-4">
						<Scan className="h-6 w-6 text-red-500 shrink-0" strokeWidth={1.5} />
						<div>
							<h3 className="font-semibold text-zinc-900">
								{t.qrCodePage.sealModal.framingTitle}
							</h3>
							<p className="text-sm text-zinc-500">
								{t.qrCodePage.sealModal.framingDesc}
							</p>
						</div>
					</div>

					<div className="flex items-start gap-4">
						<Focus
							className="h-6 w-6 text-red-500 shrink-0"
							strokeWidth={1.5}
						/>
						<div>
							<h3 className="font-semibold text-zinc-900">
								{t.qrCodePage.sealModal.focusTitle}
							</h3>
							<p className="text-sm text-zinc-500">
								{t.camera.instructions.focusDesc}
							</p>
						</div>
					</div>
					<Button
						variant="outline"
						className="w-full mt-4 bg-primary text-white hover:cursor-pointer hover:bg-primary/90 hover:text-white"
						onClick={() => onOpenChange(false)}
					>
						{t.camera.instructions.button}
					</Button>
				</div>
			</DialogContent>
		</Dialog>
	);
}
